// client/src/coms/views/canvas_parts/party/PartyDrawingView.js
// Read-only party drawings: one drawing, or several stacked as layers, re-rendered when live pictures or
// strokes arrive.
import React, { useEffect, useRef } from 'react';
import { BOARD, renderItems, renderLayers, renderModel } from './partyDrawingModel';

function fitCanvas(canvas, width) {
  if (!canvas) return;
  const dpr = Math.min(2, (typeof window !== 'undefined' && window.devicePixelRatio) || 1);
  const w = Math.round(width);
  const h = Math.round((width * BOARD.h) / BOARD.w);
  if (canvas.width !== Math.round(w * dpr)) canvas.width = Math.round(w * dpr);
  if (canvas.height !== Math.round(h * dpr)) canvas.height = Math.round(h * dpr);
}

export default function PartyDrawingView({ store, drawingId = '', layers = null, items = null, width = 320, fluid = false, label = '', className = '', testId }) {
  const canvasRef = useRef(null);
  const boxRef = useRef(null);
  const ids = layers || (drawingId ? [drawingId] : []);
  const key = ids.join(',');

  useEffect(() => {
    let frame = 0;
    const draw = () => {
      frame = 0;
      const canvas = canvasRef.current;
      if (!canvas) return;
      const box = boxRef.current;
      const target = fluid && box ? Math.max(120, box.clientWidth) : width;
      fitCanvas(canvas, target);
      const ctx = canvas.getContext('2d');
      if (items) {
        renderItems(ctx, items);
        return;
      }
      const models = ids.map((id) => (store ? store.get(id) : null));
      if (ids.length > 1) renderLayers(ctx, models, { onImage: schedule });
      else renderModel(ctx, models[0], { onImage: schedule });
    };
    function schedule() {
      if (!frame) frame = window.requestAnimationFrame(draw);
    }
    draw();
    const unsubscribers = store ? ids.map((id) => {
      store.request(id);
      return store.subscribe(id, schedule);
    }) : [];
    let observer = null;
    if (fluid && boxRef.current && typeof ResizeObserver !== 'undefined') {
      observer = new ResizeObserver(schedule);
      observer.observe(boxRef.current);
    }
    return () => {
      unsubscribers.forEach((fn) => fn && fn());
      if (observer) observer.disconnect();
      if (frame) window.cancelAnimationFrame(frame);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [store, key, width, fluid, items]);

  return (
    <div ref={boxRef} className={`party-drawing-view ${className}`} style={fluid ? { width: '100%' } : { width }} data-testid={testId}>
      <canvas ref={canvasRef} role="img" aria-label={label || 'Drawing'} style={{ width: '100%', height: 'auto', display: 'block', aspectRatio: `${BOARD.w} / ${BOARD.h}` }} />
    </div>
  );
}
